import { isUserJobseeker, isUserMentor } from 'shared-utils';
import { MeetingStatus, SubRoundType, UIMeeting, UserRole } from 'types';

export const stringAvatar = (name: string): string => {
	if (!name) return '';
	const strgs = name?.trim()?.replace(/\s+/g, ' ')?.split(' ');
	return `${strgs.length > 1 ? strgs[0][0] + strgs[1][0] : strgs[0][0]}`;
};

export function convertSubRoundTypeIntoReadble(subRoundType: SubRoundType): string {
	let subRoundTypeString = '';
	if (subRoundType === SubRoundType.Javaandspring) {
		subRoundTypeString = 'Java & Spring';
	} else if (subRoundType === SubRoundType.Nodeandexpress) {
		subRoundTypeString = 'Node & Express';
	} else if (subRoundType === SubRoundType.React) {
		subRoundTypeString = 'React';
	} else if (subRoundType === SubRoundType.Pythonanddjango) {
		subRoundTypeString = 'Django (Python)';
	} else if (subRoundType === SubRoundType.Pythonandflask) {
		subRoundTypeString = 'Flask (Python)';
	} else if (subRoundType === SubRoundType.Mern) {
		subRoundTypeString = 'MERN';
	} else if (subRoundType === SubRoundType.DA) {
		subRoundTypeString = 'Data Analytics';
	}
	return subRoundTypeString;
}

export const isScoreRangeValid = (score: number) => {
	if (0 <= score && score <= 1000) {
		return score;
	} else if (score > 1000) {
		return 1000;
	}

	return 0;
};

export const mapMeetingStatusForEndUser = (meetings: UIMeeting[], userRole: UserRole) => {
	return meetings.map(meeting => {
		let newStatus =
			(isUserJobseeker(userRole) && meeting.meetingStatus === MeetingStatus.JOBSEEKERRESCHEDULED) ||
			(isUserMentor(userRole) && meeting.meetingStatus === MeetingStatus.MENTORRESCHEDULED)
				? MeetingStatus.RESCHEDULED
				: meeting.meetingStatus;
		newStatus =
			(isUserJobseeker(userRole) && meeting.meetingStatus === MeetingStatus.JOBSEEKERCANCELLED) ||
			(isUserMentor(userRole) && meeting.meetingStatus === MeetingStatus.MENTORCANCELLED)
				? MeetingStatus.CANCELLED
				: newStatus;
		return {
			...meeting,
			status: newStatus,
		};
	});
};
